import {Route, Routes} from 'react-router-dom';
import './CSS/App.css';
import Header from "./COMPONENT/BASIC/Header";
import Footer from "./COMPONENT/BASIC/Footer";
import Main from "./BAS/Main";
import About from "./BAS/About";
import Rooms from "./BAS/Rooms";
import Reservation from "./BAS/Reservation";
import Services from "./BAS/Services";
import Gallery from "./BAS/Gallery";


function App() {

    return (
        <>
            <div className="app-container">
                <Header />
                <div className="content-container">
                    <Routes>
                        <Route path="/" element={<Main/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/rooms" element={<Rooms/>}/>
                        <Route path="/reservation" element={<Reservation/>}/>
                        <Route path="/services" element={<Services/>}/>
                        <Route path="/gallery" element={<Gallery/>}/>
                    </Routes>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default App;
